import {StyleSheet} from 'aphrodite';

const styles = StyleSheet.create({
    loadingItem: {
        paddingBottom: 30
    }
});

export default styles;
